import React from "react";
import CustomLoaderLiquid from "../CustomLoaderLiquid/customLoaderLiquid.component";

type ErrorBoundaryProps = {
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state = {
    hasError: false,
    isReloading: false // Add a new state to indicate reloading
  };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, isReloading: false };
  }

  componentDidCatch(error: Error, errorInfo: unknown) {
    console.error("ErrorBoundary caught an error: ", error, errorInfo);
    if (error.name === "ChunkLoadError") {
      const reloads = parseInt(
        localStorage.getItem("errorReloadCount") || "0",
        10
      );
      const lastReload = parseInt(
        localStorage.getItem("errorLastReload") || "0",
        10
      );
      const currentTime = Date.now();

      // Check if the last reload was more than 1 minute ago
      if (currentTime - lastReload > 60000) {
        localStorage.setItem("errorReloadCount", "1");
        localStorage.setItem("errorLastReload", currentTime.toString());
        this.setState({ isReloading: true });
        window.location.reload();
      } else if (reloads < 3) {
        // Limit to 3 reloads within a minute
        localStorage.setItem("errorReloadCount", (reloads + 1).toString());
        localStorage.setItem("errorLastReload", currentTime.toString());
        this.setState({ isReloading: true });
        window.location.reload();
      } else {
        console.error("Too many reloads due to ChunkLoadError");
      }
    }
  }

  render() {
    if (this.state.hasError) {
      // Show loading screen if isReloading is true
      if (this.state.isReloading) {
        return (
          <div className="container mx-auto h-svh overflow-hidden px-4 pt-4">
            <CustomLoaderLiquid />
          </div>
        );
      }

      // Fallback UI if an error is caught
      return (
        this.props.fallback || (
          <div className="container m-auto">
            <div className="mt-4 text-center text-3xl font-bold text-red-600">
              <h1>Something went wrong.</h1>
            </div>
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
